import {
  MAKE_TYPE,
  MODEL_TYPE,
  YEAR_START_TYPE,
  YEAR_END_TYPE,
  REGION_TYPE,
  VEHICLE_TYPE,
  SUB_MODEL_TYPE,
} from '../advanced-search/filter-types';

export const filterPlaceholders: any = {
  [MAKE_TYPE]: {
    option: 0,
    title: 'Vehicle Make',
    type: MAKE_TYPE,
  },
  [MODEL_TYPE]: {
    option: 0,
    title: 'Model',
    selected_make_name: 'Model',
    empty_make_name: 'Model (select make)',
    type: MODEL_TYPE,
  },
  [YEAR_START_TYPE]: {
    option: 0,
    title: 'Year',
    type: YEAR_START_TYPE,
  },
  [YEAR_END_TYPE]: {
    option: 0,
    title: 'Year',
    type: YEAR_END_TYPE,
  },
  [REGION_TYPE]: {
    option: 0,
    title: 'Region',
    type: REGION_TYPE,
  },
  [VEHICLE_TYPE]: {
    option: 0,
    title: 'Vehicle type',
    type: VEHICLE_TYPE,
  },
  [SUB_MODEL_TYPE]: {
    option: 0,
    title: 'Sub Model',
    type: SUB_MODEL_TYPE,
  },
};
